import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';

const STAFFING_BOARD_API = '/api/v1/staffing-board';

// ─── Types ───────────────────────────────────────────────────────────────────

export type DeliveryStatus = 'queued' | 'sent' | 'delivered' | 'failed' | 'no_channel';

export interface DispatchPacket {
  tech_id: number;
  tech_name: string;
  project_name: string;
  status: 'sent' | 'viewed' | 'acknowledged';
  sent_via: string;
  delivery_status: DeliveryStatus;
  delivered_at: string;
}

export interface DispatchBatch {
  batch_id: string;
  dispatched_at: string;
  project_count: number;
  tech_count: number;
  packets: DispatchPacket[];
}

export interface DispatchHistoryResponse {
  batches: DispatchBatch[];
}

// ─── Query ───────────────────────────────────────────────────────────────────

export function useDispatchHistory(enabled = true) {
  return useQuery<DispatchHistoryResponse>({
    queryKey: queryKeys.staffingBoard.dispatches(),
    queryFn: async () => {
      const response = await apiClient.get<DispatchHistoryResponse>(
        `${STAFFING_BOARD_API}/dispatches/`,
      );
      return response.data;
    },
    enabled,
  });
}
